var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconContanct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#118CE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.2927 34.1043C95.6874 34.3697 96.8207 35.0554 97.6924 36.1613C98.5641 37.2672 99 38.5722 99 40.0763C99 48.0389 97.4527 55.6698 94.358 62.9689C91.2634 70.2681 87.1227 76.5497 81.9359 81.8139C76.7491 87.0781 70.5816 91.2585 63.4334 94.3551C56.2852 97.4517 48.7448 99 40.812 99C39.4173 99 38.1751 98.5576 37.0854 97.6729C35.9957 96.7881 35.3202 95.638 35.0586 94.2224L32.1819 81.7476C31.8332 80.332 31.9858 78.9606 32.6396 77.6335C33.2934 76.3064 34.3177 75.3774 35.7124 74.8466L48.9191 69.0073C50.1396 68.4765 51.4036 68.388 52.7112 68.7419C54.0188 69.0958 55.1084 69.8036 55.9801 70.8653L60.1644 76.1737C67.2255 72.2808 72.6738 66.7512 76.5094 59.5848L71.279 55.3381C70.2329 54.4533 69.5573 53.3474 69.2522 52.0203C68.9471 50.6932 69.0125 49.4103 69.4484 48.1717L75.2018 34.7678C75.812 33.3523 76.7491 32.3127 78.0131 31.6491C79.2771 30.9856 80.6065 30.8307 82.0013 31.1846L94.2927 34.1043ZM41.0736 92.6299C50.4011 92.6299 59.0312 90.2853 66.9639 85.5962C74.8967 80.9071 81.1731 74.5369 85.7933 66.4858C90.4135 58.4346 92.7235 49.6757 92.7235 40.209L80.8244 37.4221L75.3325 50.5605L84.2242 57.8596C81.2603 64.4066 77.8388 69.6266 73.9596 73.5195C70.0804 77.4123 64.9154 80.9071 58.4646 84.0036L51.2728 74.9793L38.3276 80.5532L41.0736 92.6299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconContanct);
export default __webpack_public_path__ + "static/media/phone_icon -contanct.07e63be0f6c71bba1d3dfad06be9bc12.svg";
export { ForwardRef as ReactComponent };